module.exports = __webpack_public_path__ + "58ad38e4a4e8e8774887d22ada632754.svg";


//////////////////
// WEBPACK FOOTER
// ./images/step-complete.svg
// module id = 1142
// module chunks = 0